import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition, faCheck, faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { faExclamationTriangle as faExclamationTriangleRegular } from '@fortawesome/pro-regular-svg-icons';
import { isBoolean } from 'src/utils/typeGuards';
import styles from './ScriptActivationIcon.module.less';

export enum IconState {
  Active = 'active',
  Inactive = 'inactive',
  Warning = 'warning',
}

export namespace IconState {
  export const fromBoolean = (isActive: boolean): IconState => {
    return isActive ? IconState.Active : IconState.Inactive;
  };
}

const mapping = {
  [IconState.Active]: {
    icon: faCheck,
    className: styles.active,
  },
  [IconState.Inactive]: {
    icon: faExclamationTriangle,
    className: styles.inactive,
  },
  [IconState.Warning]: {
    icon: faExclamationTriangleRegular,
    className: styles.warning,
  },
} satisfies Record<IconState, { icon: IconDefinition; className: string }>;

type ScriptIconProps = {
  value: boolean | IconState;
  className?: string;
};

const ScriptActivationIcon: React.FC<ScriptIconProps> = ({ value, className }) => {
  const props = mapping[isBoolean(value) ? IconState.fromBoolean(value) : value];
  return <FontAwesomeIcon {...props} className={clsx(className, props.className)} size="lg" />;
};

export default ScriptActivationIcon;
